module.exports = __webpack_public_path__ + "static/media/question.b23c185f.svg";